import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ColDef, GridApi, ICellRendererParams } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { AppRoleOption } from 'src/app/app-roles';
import { MenuStateService } from 'src/app/menu-state.service';
import { ManageSubMenuItemsComponent } from '../manage-sub-menu-items/manage-sub-menu-items.component';
import { buildRoleAccessColumns, setRoleAccess } from '../menu-role-access';

@Component({
  selector: 'app-manage-menu-items',
  templateUrl: './manage-menu-items.component.html',
  styleUrls: ['./manage-menu-items.component.scss']
})
export class ManageMenuItemsComponent implements OnInit {

  menu_items: any[] = [];
  private gridApi!: GridApi;
  public detailCellRenderer: any = ManageSubMenuItemsComponent;
  themeMode: 'light' | 'dark' = 'light';

  constructor(private http: HttpClient, private toastr: ToastrService, private menuStateService: MenuStateService) { }

  ngOnInit() {
    this.menuStateService.themeState$.subscribe((theme) => {
      this.themeMode = theme === 'ams-content-dark' ? 'dark' : 'light';
    });
    this.loadMenuItems();
  }

  toggleTheme() {
    this.menuStateService.toggleTheme();
  }

  getThemeIcon(): string {
    return this.themeMode === 'dark' ? 'fa-solid fa-sun' : 'fa-solid fa-moon';
  }

  getThemeLabel(): string {
    return this.themeMode === 'dark' ? 'Light' : 'Dark';
  }

  private loadMenuItems() {
    this.http.get('/api/menu_manager/menu_manager.php', { params: { type: 'menu' } }).subscribe((response: any) => {
      this.menu_items = response ?? [];
    });
  }

  menuColumnDefs: ColDef[] = [
    {
      field: 'ams_side_menu_text',
      headerName: 'Menu',
      width: 240,
      minWidth: 220,
      pinned: 'left',
      lockPinned: true,
      cellRenderer: 'agGroupCellRenderer'
    },
    ...buildRoleAccessColumns('ams_side_menu_text', (checked, params, role) => {
      this.checkboxChanged(checked, params, role);
    }),
  ];

  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: false,
  };

  onGridReady(params: any) {
    this.gridApi = params.api;
  }

  checkboxChanged(checked: boolean, params: ICellRendererParams<any, any, any>, role: AppRoleOption) {
    const row = params.data;
    const menuId = row?.ams_side_menu_id;

    if (!menuId) {
      return;
    }

    const previousAccessRoles = row.access_roles;
    const nextAccessRoles = setRoleAccess(previousAccessRoles, role.value, checked);

    if (nextAccessRoles === Number(previousAccessRoles)) {
      return;
    }

    row.access_roles = nextAccessRoles;
    params.api.refreshCells({ rowNodes: params.node ? [params.node] : undefined, force: true });

    this.http.get('/api/menu_manager/menu_manager.php', {
      params: { type: 'updateAccessMenu', access_roles: nextAccessRoles, menu_id: menuId }
    }).subscribe({
      next: () => {
        this.toastr.success(`${role.label} access updated.`);
        this.loadMenuItems();
      },
      error: () => {
        row.access_roles = previousAccessRoles;
        params.api.refreshCells({ rowNodes: params.node ? [params.node] : undefined, force: true });
        this.toastr.error('Unable to update menu access.');
      }
    });
  }

}
